import React, { FC } from "react";
import { DividerSizeVariant } from "./DividerSizeVariant";
import classNames from "classnames";
import { assertNever } from "../Helpers";

interface DividerProps {
	size?: DividerSizeVariant;
	className?: string;
}

export const Divider: FC<DividerProps> = (props) => {
	const { size = "thin", className } = props;

	const getDividerVariantClassName = () => {
		switch (size) {
			case "thin":
				return "Divider--thin";
			case "medium":
				return "Divider--medium";
			case "bold":
				return "Divider--thick";
			default:
				return assertNever(size);
		}
	};

	return (
		<div
			role="separator"
			className={classNames("Divider", getDividerVariantClassName(), className)}
		/>
	);
};
